import { type FC } from 'react';

import { type IconProps } from './types';

export const ArrowsForm3V4Icon: FC<IconProps> = () => {
  return (
    <svg width="31" height="31" viewBox="0 0 31 31" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M1 0V30H31" stroke="#FFDD00" strokeWidth="2" />
    </svg>
  );
};
